import InvoiceInfo from "features/invoices/components/InvoiceInfo";
import React from "react";
import PaymentUsageDTO from "../dtos/PaymentUsageDTO";
import { useTranslation } from "react-i18next";
interface IProps {
  paymentUsage: PaymentUsageDTO[];
  showInvoiceTimePeriod?: boolean;
}

const PaymentUsage: React.FC<IProps> = (props) => {
  // translations
  const tLabels = useTranslation("payments\\payments").t;

  // props
  const {paymentUsage, showInvoiceTimePeriod} = props;

  // render
  if (paymentUsage.length > 0) {
    if (paymentUsage.length === 1) {
      let invoice = paymentUsage[0].invoiceUsage;

      return (
        <InvoiceInfo
          invoiceType={invoice?.invoiceType!}
          invoiceSubType={invoice?.invoiceSubType!}
          commodityDetails={invoice?.commodityDetail!}
          entityLinks={invoice?.entityLinks!}
          timePeriodFrom={invoice?.timePeriodFrom}
          timePeriodTo={invoice?.timePeriodTo}
          mobileBehaviour
          showTimePeriod={showInvoiceTimePeriod}
        />
      );
    } else {
      return (
        <div className="text-truncate text-muted pl-sm-2">
          <span className="d-sm-none">{tLabels("paymentUsage.paymentUsage")}</span>
          <span className="d-none d-sm-inline">{tLabels("paymentUsage.payment")}</span>
          <span>{paymentUsage.length}{tLabels("paymentUsage.document")}</span>
        </div>
      );
    }
  } else {
    return null;
  }
};

export default PaymentUsage;